import Furnace from './Furnace';

export default Furnace;
